module.exports = __webpack_public_path__ + "208d586e02cb267c6d7b0a9e744a45b2.png";